import AddressInput from './AddressInput.view';

export default AddressInput;
